// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3NSXf","content":"styles_content__1Zhpw","selectAll":"styles_selectAll__3lG5t"};